import {isGoogleTagManagerEnabled} from './isGoogleTagManagerEnabled';
import {getTrackingContext} from './trackingContext';

export function pushDataLayerEvent(
  event: string,
  payload: Record<string, unknown> = {},
): void {
  if (!isGoogleTagManagerEnabled()) {
    return;
  }

  globalThis.dataLayer = globalThis.dataLayer ?? [];
  globalThis.dataLayer.push({
    ...getTrackingContext(),
    ...payload,
    event,
  });
}
